
import ware from "@/components/cms-sell/ware.vue"

const fen2Yuan = num => {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2).toString().split(".")
}
export default {
  name: "ProRec",
  components: {
    ware
  },
  props: {
    configData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      scroll: null,
      showArrow: true,
      showArrowLeft: false,
      wareData: [],
      groupTitle: "",
      styleConfig: {
        marginRight: ".1rem"
      },
      commonReqParams: {}
    }
  },
  watch: {
    configData: {
      handler(newVal) {
        this.wareData = this.transformData(newVal)
        this.wareData = this.wareData.map(element => {
          if (element.addCartCount) {
            return { ...element, goodsNummberShow: true }
          } else {
            return { ...element, goodsNummberShow: false }
          }
        })
      },
      immediate: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {},
  methods: {
    goodsNummberShow(item) {
      this.wareData = this.wareData.map(ele => {
        if (ele.spId === item.spId) {
          return item
        } else {
          return ele
        }
      })
    },
    transformData(data) {
      const result = []
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          const promotionPrice = data[i].additional?.promotionPrice
          const promotionPriceArr = fen2Yuan(promotionPrice)
          data[i].additional.promotionPriceVal = promotionPriceArr[0]
          data[i].additional.promotionPriceVal2 = promotionPriceArr[1]
          const nameArr = data[i].additional.name.split(" ")
          data[i].additional.nameVal = nameArr[0]
          data[i].additional.nameUnit = nameArr[1]
          data[i].additional.showSubTypeName =
            data[i].additional.promotionList && data[i].additional.promotionList.length > 1
              ? this.$t("common.multipleOffers")
              : data[i].additional.promotionList &&
                  data[i].additional.promotionList[0] &&
                  data[i].additional.promotionList[0].subTypeName
                ? data[i].additional.promotionList[0].subTypeName
                : ""
          data[i].additional.showSoldOut = [1, 2].includes(data[i].additional.wareStatus)
          result.push(data[i])
        }
      }
      return result
    }
  }
}
